module.exports = __webpack_public_path__ + "static/media/notice1.34f3f999.png";